<template>
    <div>
        <el-breadcrumb
            v-if="hasRoleToReadLogs"
            style="float: right"
            separator-class="el-icon-arrow-right"
        >
            <el-breadcrumb-item :to="{ path: '/' }">{{$t('route.home')}}</el-breadcrumb-item>
            <el-breadcrumb-item>{{$t('route.teams')}}</el-breadcrumb-item>
        </el-breadcrumb>

        <h2 class="page-title">{{$t('entities.team.plural')}}</h2>

        <el-row :gutter="20">
            <el-col :xs="24" :md="8">
                <el-form @submit.native.prevent class="search" :inline="true">
                    <el-form-item>
                        <el-input v-model="pager.search" :placeholder="$t('table.search')">
                            <el-button slot="append" icon="el-icon-search"></el-button>
                        </el-input>
                    </el-form-item>
                </el-form>
            </el-col>

            <el-col class="button-group" :xs="24" :md="16">
                <el-button
                    v-if="hasRoleToCreate"
                    icon="el-icon-fa-file-o"
                    @click="create()"
                    type="primary"
                >{{$t('table.add')}}</el-button>
                <el-button
                    v-if="hasRoleToReadLogs"
                    icon="el-icon-fa-history"
                    @click="history()"
                    type="infor"
                >{{$t('table.history')}}</el-button>
                <el-button
                    v-if="pager.hasDataToExport(list) && hasRoleToReadLogs"
                    @click="pager.exportToCsv(list)"
                    :plain="true"
                    type="success"
                    icon="el-icon-fa-table"
                >{{$t('table.export')}}</el-button>
            </el-col>
        </el-row>
        <!-- ************************** -->
        <!-- *                        * -->
        <!-- *  Players import data   * -->
        <!-- *                        * -->
        <!-- ************************** -->
        <transition name="fade" mode="out-in">
            <router-view name="playerImport"></router-view>
        </transition>
        <el-table
            :data="pager.paginate(list)"
            :default-sort="{
        prop: 'name',
        order: 'ascending'
      }"
            @row-click="rowClick"
            :empty-text="emptyText"
            @sort-change="(args) => pager.sortChange(args)"
            style="width: 100%"
            v-loading="loading"
            border
        >
            <el-table-column prop="name" :label="$t('entities.team.prop.name')" sortable="custom"></el-table-column>

            <el-table-column prop="category" :label="$t('entities.team.prop.category')" sortable="custom">
                <template
                    slot-scope="scope"
                >{{ scope.row.category ? scope.row.category.label : '' }}</template>
            </el-table-column>
            
            <!-- <el-table-column
                v-if="club"
                prop="club"
                :label="$t('entities.club.singular')"
                sortable="custom"
            >
                <template slot-scope="scope">{{ scope.row.club ? scope.row.club.name : '' }}</template>
            </el-table-column> -->

            <el-table-column
                v-if="hasRoleToReadLogs"
                prop="locality"
                :label="$t('entities.team.prop.locality')"
                sortable="custom"
            ></el-table-column>

            <el-table-column
                v-if="hasRoleToReadLogs"
                prop="country"
                :label="$t('entities.team.prop.country')"
                sortable="custom"
            ></el-table-column>

            <el-table-column
                v-if="hasRoleToReadLogs"
                prop="web"
                :label="$t('entities.team.prop.web')"
                sortable="custom"
            ></el-table-column>
            
            <!-- Size players -->
            <el-table-column
                prop="sizePlayers"
                :label="$t('entities.player.numberOfPlayers')"
                sortable="custom"
            >
                <template slot-scope="scope">{{ getSize(scope.row.players) }}</template>
            </el-table-column>
            <!-- Size coaches -->
            <el-table-column
                prop="sizePlayers"
                :label="$t('entities.coach.numberOfCoaches')"
                sortable="custom"
            >
                <template slot-scope="scope">{{ getSize(scope.row.coaches) }}</template>
            </el-table-column>
            <!-- Size team managers -->
            <el-table-column
                prop="sizePlayers"
                :label="$t('entities.teamManager.numberOfTeamManager')"
                sortable="custom"
            >
                <template slot-scope="scope">{{ getSize(scope.row.teamManagers) }}</template>
            </el-table-column>


            <!-- ************************** -->
            <!-- *                        * -->
            <!-- *         Actions        * -->
            <!-- *                        * -->
            <!-- ************************** -->
            <el-table-column
                :fixed="isMobile? undefined : 'right'"
                align="center"
                :label="$t('table.actions')"
                width="160"
            >
                <template slot-scope="scope">
                    <el-tooltip
                        v-if="hasRoleToUpdate"
                        :content="$t('entities.team.exportTeamAsPdf')"
                        placement="top"
                    >
                        <el-button
                            icon="el-icon-download"
                            size="medium"
                            type="text"
                            @click="exportTeamAsPdf(scope.row)"
                        />
                    </el-tooltip>
                    <el-tooltip
                        v-if="hasRoleToUpdate"
                        :content="$t('entities.player.importPlayers')"
                        placement="top"
                    >
                        <el-button
                            icon="el-icon-upload2"
                            size="medium"
                            type="text"
                            @click="importPlayers(scope.row)"
                        />
                    </el-tooltip>
                    <el-tooltip
                        v-if="hasRoleToRead || hasRoleToReadClub"
                        :content="$t('table.details')"
                        placement="top"
                    >
                        <el-button
                            icon="el-icon-fa-search"
                            size="small"
                            type="text"
                            @click="show(scope.row.id)"
                        />
                    </el-tooltip>

                    <el-tooltip v-if="hasRoleToUpdate" :content="$t('table.edit')" placement="top">
                        <el-button
                            icon="el-icon-fa-pencil-square-o"
                            size="small"
                            type="text"
                            @click="edit(scope.row.id)"
                        />
                    </el-tooltip>

                    <el-tooltip
                        v-if="hasRoleToDelete"
                        :content="$t('table.delete')"
                        placement="top"
                    >
                        <el-button
                            icon="el-icon-fa-trash"
                            size="small"
                            type="text"
                            @click="destroy(scope.row)"
                        />
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>

        <div class="mt-3">
            <el-pagination
                style="float: right"
                @size-change="(args) => pager.pageSizeChange(args)"
                :current-page.sync="pager.currentPage"
                :layout="paginationLayout"
                :total="pager.filteredAndSortedList(list).length"
                background
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "underscore";

/* eslint-disable */
export default {
    name: "app-team-list",

    props: {
        clubId: String
    },

    data() {
        return {
            title: "Equipos",
            labels: {
                name: "Nombre",
                category: "Categoría"
            },
            breadcrumbLabels: {
                home: "Inicio",
                teams: "Equipos",
                edit: "Editar",
                new: "Nuevo"
            },
            emptyText: "There are no teams yet"
        };
    },

    computed: {
        ...mapGetters({
            loading: "entities/team/loading",
            list: "entities/team/list",
            pager: "entities/team/pager",
            hasRoleToDelete: "entities/team/hasRoleToDelete",
            hasRoleToUpdate: "entities/team/hasRoleToUpdate",
            hasRoleToRead: "entities/team/hasRoleToRead",
            hasRoleToReadClub: "entities/club/hasRoleToRead",
            hasRoleToReadLogs: "entities/team/hasRoleToReadLogs",
            hasRoleToCreate: "entities/team/hasRoleToCreate",
            isMobile: "shared/isMobile",
            paginationLayout: "shared/paginationLayout"
        })
    },

    created() {
        if (this.clubId) {
            this.$store.dispatch("entities/team/listByClubId", this.clubId);
        } else {
            this.$store.dispatch("entities/team/list");
        }
    },

    beforeRouteLeave(to, from, next) {
        console.log("<--- beforeRouteUpdate");

        this.$store.dispatch("entities/team/clear");
        next();
    },

    beforeRouteUpdate(to, from, next) {
        console.log("<--- beforeRouteUpdate");

        console.log(to);
        console.log(from);

        this.$store.dispatch("entities/team/list");
        next();
    },

    methods: {
        create() {
            this.$router.push({
                name: "teamNew"
            });
        },

        rowClick(row, column, cell, event) {
            if (cell.label != this.$t("table.actions")) {
                this.$router.push({
                    name: "teamShow",
                    params: { id: row.id }
                });
            }
        },

        importPlayers(team) {
            this.$store.dispatch("entities/team/importPlayersSetup", team).then((teamSetup) => {
                this.$store.dispatch('entities/player/import/setup', teamSetup);
                this.$router.push({
                    name: "playerImportCsv"
                 });
            });
        },

        exportTeamAsPdf(team) {
           this.$store
                    .dispatch("entities/team/exportAsPDF", team)
                  
        },

        show(id) {
            console.log("*******");
            console.log(id);

            this.$router.push({
                name: "teamShow",
                params: { id }
            });
        },

        edit(id) {
            this.$router.push({
                name: "teamEdit",
                params: { id }
            });
        },

        destroy(model) {
            this.$confirm(this.$t("table.areYouSure"), this.$t("table.confirm"), {
                confirmButtonText: this.$t("table.yes"),
                cancelButtonText: this.$t("table.no"),
                type: 'warning',
            })
            .then(() =>
                this.$store
                    .dispatch("entities/team/destroy", model)
                    .then(() => {
                        if (this.clubId) {
                            this.$store.dispatch(
                                "entities/team/listByClubId",
                                this.clubId
                            );
                        } else {
                            this.$store.dispatch("entities/team/list");
                        }
                    })
            )
            .catch(() => {});
        },

        history() {
            this.$router.push({ name: "teamHistoryFull" });
        },

        // Auz functions

        getSize(obj) {
            return _.size(obj);
        }
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/entities/team/team-list.vue?05e51918